import React from 'react';
import { Cake } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { format } from 'date-fns';

const BirthdaysCard = ({ upcomingBirthdays }) => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="flex items-center gap-2">
          <Cake className="h-5 w-5 text-pink-500" />
          Upcoming Birthdays (30 Days)
        </CardTitle>
        <Badge variant="outline" className="bg-pink-50 text-pink-700">
          {upcomingBirthdays?.length || 0}
        </Badge>
      </CardHeader>
      <CardContent>
        {!upcomingBirthdays || upcomingBirthdays.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No upcoming birthdays in the next 30 days</p>
        ) : (
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {upcomingBirthdays.map((birthday) => (
              <div 
                key={birthday.employee_id} 
                className={`flex items-center justify-between p-3 rounded-lg border ${
                  birthday.days_until === 0 
                    ? 'bg-pink-100 border-pink-300' 
                    : birthday.days_until <= 7
                    ? 'bg-pink-50 border-pink-200'
                    : 'bg-gray-50 border-gray-200'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className="bg-pink-100 p-2 rounded-full">
                    <Cake className="h-4 w-4 text-pink-600" />
                  </div>
                  <div>
                    <p className="font-medium text-sm">{birthday.employee_name}</p>
                    <p className="text-xs text-gray-600">{birthday.employee_code} - {birthday.department}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium">
                    {format(new Date(birthday.birthday_date), 'MMM dd')}
                  </p>
                  <p className={`text-xs ${birthday.turning_age >= 60 ? 'text-orange-600 font-bold' : 'text-gray-500'}`}>
                    Turning {birthday.turning_age}
                    {birthday.days_until === 0 && <span className="ml-1 text-pink-600">Today!</span>}
                    {birthday.days_until > 0 && birthday.days_until <= 7 && <span className="ml-1 text-pink-600">({birthday.days_until} days)</span>}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BirthdaysCard;
